import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import VentasCompleto from './pages/VentasCompleto';
import VentaRetroactiva from './pages/VentaRetroactiva';
import StockCompleto from './pages/StockCompleto';
import ImportarStock from './pages/ImportarStock';
import BusDetalle from './pages/BusDetalle';
import BusesCompleto from './pages/BusesCompleto';
import Creditos from './pages/Creditos';
import ReportesCompleto from './pages/Reportes';
import MantenimientosCompleto from './pages/MantenimientosCompleto';
import QuejasCompleto from './pages/QuejasCompleto';
import MecanicosCompleto from './pages/MecanicosCompleto';
import CajaCentral from './pages/CajaCentral';
import Gastos from './pages/Gastos';
import PagoMantenimiento from './pages/PagoMantenimiento';
import Nomina from './pages/Nomina';
import Adelantos from './pages/Adelantos';
import Auditoria from './pages/Auditoria';
import ImportarDatos from './pages/ImportarDatos';
import DataAntigua from './pages/DataAntigua';
import Asistencia from './pages/Asistencia';
import CajaRepuestos from './pages/CajaRepuestos';
import ComprobantesCaja from './pages/ComprobantesCaja';
import CierreCaja from './pages/CierreCaja';
import Ayuda, { AyudaImprimir } from './pages/Ayuda';

function RutaProtegida({ children }: { children: JSX.Element }) {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/ayuda/imprimir" element={<RutaProtegida><AyudaImprimir /></RutaProtegida>} />
          <Route path="/" element={<RutaProtegida><Layout /></RutaProtegida>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="ventas" element={<VentasCompleto />} />
            <Route path="ventas/retroactiva" element={<VentaRetroactiva />} />
            <Route path="stock" element={<StockCompleto />} />
            <Route path="stock/importar" element={<ImportarStock />} />
            <Route path="buses" element={<BusesCompleto />} />
            <Route path="buses/:id" element={<BusDetalle />} />
            <Route path="creditos" element={<Creditos />} />
            <Route path="reportes" element={<ReportesCompleto />} />
            <Route path="mantenimientos" element={<MantenimientosCompleto />} />
            <Route path="quejas" element={<QuejasCompleto />} />
            <Route path="caja-mantenimiento" element={<CajaCentral caja="mantenimiento" />} />
            {/* 2026-10-10: Caja Ventas + Caja Chica = Caja Repuestos (caja interna 'ventas') */}
            <Route path="caja-ventas" element={<Navigate to="/caja-repuestos" replace />} />
            <Route path="caja-servicios" element={<CajaCentral caja="servicios" />} />
            <Route path="caja-central" element={<Navigate to="/caja-repuestos" replace />} />
            <Route path="fondo-caja-chica" element={<Navigate to="/caja-repuestos" replace />} />
            <Route path="caja-repuestos" element={<CajaCentral caja="ventas" />} />
            <Route path="cierre-caja" element={<CierreCaja />} />
            <Route path="comprobantes-caja" element={<ComprobantesCaja />} />
            <Route path="compras-repuestos" element={<CajaRepuestos />} />
            <Route path="gastos" element={<Gastos />} />
            <Route path="pagos" element={<Nomina />} />
            <Route path="pago-mantenimiento" element={<PagoMantenimiento />} />
            <Route path="mecanicos" element={<MecanicosCompleto />} />
            <Route path="asistencia" element={<Asistencia />} />
            <Route path="adelantos" element={<Adelantos />} />
            <Route path="auditoria" element={<Auditoria />} />
            <Route path="importar-datos" element={<ImportarDatos />} />
            <Route path="data-antigua" element={<DataAntigua />} />
            <Route path="ayuda" element={<Ayuda />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
